module.exports = __webpack_public_path__ + "static/media/tvendo-icon-web.64b01332.png";